import { render, staticRenderFns } from "./coberturas.vue?vue&type=template&id=47afe504&scoped=true&"
import script from "./coberturas.vue?vue&type=script&lang=js&"
export * from "./coberturas.vue?vue&type=script&lang=js&"
import style0 from "./coberturas.vue?vue&type=style&index=0&id=47afe504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afe504",
  null
  
)

export default component.exports